React = require 'react'
t = require('views/internal/recup-with-helpers')('team_banners')
_ = require 'underscore'

{
  ORG_TYPE_ENTERPRISE
  ORG_TYPE_BUSINESS_CLASS
} = require 'data/org-types'

class TeamBannerComponent extends React.Component
  displayName: 'TeamBanner'

  render: t.renderable ->
    {
      heading
      isUpgrade
      onDismissBanner
      orgDisplayName
      orgType
      subheading
      teamheading
      tips
      utmTerm
    } = @props

    isBusinessClassOrg = orgType == ORG_TYPE_BUSINESS_CLASS
    isEnterpriseOrg = orgType == ORG_TYPE_ENTERPRISE

    sectionClass = switch true
      when isEnterpriseOrg then '.team-banner-section-ent'
      when isBusinessClassOrg then '.team-banner-section-bc'
      else '.team-banner-section'

    headingUrl = if isEnterpriseOrg
      require('images/enterprise-logo-white.svg')
    else if isBusinessClassOrg
      require('images/business-class-logo-white.svg')
    else
      null

    contentClass = '.team-banner-content'
    if isUpgrade
      contentClass += '.team-banner-content-upgraded-org'

    t.div '.team-banner', =>
      t.button '.icon-lg.icon-close', onClick: onDismissBanner
      t.div sectionClass, =>
        t.div contentClass, =>
          t.div '.team-banner-welcome-section', =>
            t.h1 '.team-banner-welcome-heading', =>
              t.format heading, { url: headingUrl }
            t.p '.team-banner-welcome-subheading', =>
              if teamheading and orgDisplayName
                t.format teamheading, { team_name: orgDisplayName }
                t.raw '<br/>'
              t.format subheading
          t.ol '.team-banner-tip-list', =>
            _.map(tips, (tip, i) =>
              t.li '.team-banner-tip-list-item', =>
                t.span '.team-banner-tip-list-item-index', 'aria-hidden': true, =>
                  t.text i + 1
                t.span '.team-banner-tip-list-item-text', =>
                  if tip.imgSrc
                    t.format tip.key
                    t.a {
                      href: tip.url
                      target: '_blank'
                    }, =>
                      t.img '.team-banner-tip-list-app-download-button', {
                        alt: t.l(tip.imgAlt)
                        src: tip.imgSrc
                      }
                  else if tip.url
                    t.format tip.key, { url: tip.url }
                  else
                    t.format tip.key
            )

module.exports = TeamBannerComponent



// WEBPACK FOOTER //
// ./app/scripts/views/member/team-banner-component.coffee